import React, { createContext, useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import useAxios from "../hooks/useAxios";
import { handleFilterDateClicks } from "../pages/Candidate/components/AdvanceFilters";

export const SearchContextAPI = createContext();

const SearchContext = ({ children }) => {
  const api = useAxios();
  const id = localStorage.getItem("user.id");
  const token = localStorage.getItem("user.token");

  const isApplied = (value) => {
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "string") return value.trim() !== "";
    return Boolean(value);
  };

  const getFilters = async () => {
    try {
      const { data } = await api.get(`/candidateFilters/${id}`, {
        tokenType: "user",
      });
      let filters = data?.candidateFilters?.[0];
      if (filters) {
        const {
          applicationType,
          callStatus,
          location,
          modeOfInterview,
          position,
          qualification,
          recruiter,
          source,
          trf,
          versant,
          duration,
          interested,
          rotationalShift,
          jobType,
          candidateType,
          departmentId,
          designationId,
          whatsAppResponse,
          whatsAppCampaign,
        } = filters;

        const applied = {
          trf: trf?.[0],
          callStatus: callStatus?.[0],
          departmentId : departmentId?.[0],
          designationId: designationId?.[0],
          modeOfInterview: modeOfInterview?.[0],
          whatsAppCampaign: whatsAppCampaign?.[0],
          whatsAppResponse: whatsAppResponse?.[0],
          applicationType,
          location,
          versant,
          position,
          qualification,
          recruiter,
          source,
          interested,
          rotationalShift,
          jobType,
          candidateType,
        };

        const isTrueExist =
          Array.isArray(applicationType) && applicationType.includes(true);
        setUnassigned(isTrueExist);

        const activeFilters = Object.values(applied).filter(isApplied).length;
        setAdvanceappliedFilters(activeFilters);

        setCallMasterId(callStatus?.[0] ? callStatus?.[0] : "");
        setModeOfInterview(modeOfInterview?.[0] ? modeOfInterview?.[0] : "");
        setSelectedDatevalue(duration?.[0] ? duration?.[0] : "");
        setDefaultDate(
          handleFilterDateClicks(duration?.[0] ? duration?.[0] : ""),
        );
        setTrfId(trf?.[0] ? trf?.[0] : "");
        setWhatsAppCampaign(whatsAppCampaign?.[0] ? whatsAppCampaign?.[0] : "");
        setWhatsAppResponse(whatsAppResponse?.[0] ? whatsAppResponse?.[0] : "");
        setDepartmentId(departmentId ? departmentId : []);
        setDesignationId(designationId ? designationId : []);
        setInterested(interested ? interested : []);
        setRotationalShift(rotationalShift ? rotationalShift : []);
        setLocation(location ? [...location] : []);
        setSource(source ? [...source] : []);
        setPositions(position ? [...position] : []);
        setFormId(applicationType ? [...applicationType] : []);
        setQualification(qualification ? [...qualification] : []);
        setRecruiter(recruiter ? [...recruiter] : []);
        setVersantScore(versant ? [...versant] : []);
        setCandidateType(candidateType ? [...candidateType] : []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (id) {
        setFilterFetched(true);
      }
    }
  };

  useEffect(() => {
    if (id && token) {
      getFilters();
    }
  }, [id, token]);

  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const TAB = searchParams.get("tab" || "");
  const [search, setSearch] = useState("");
  const [interested, setInterested] = useState([]);
  const [rotationalShift, setRotationalShift] = useState([]);
  const [location, setLocation] = useState([]);
  const [trfId, setTrfId] = useState("");
  const [designationId, setDesignationId] = useState([]);
  const [departmentId, setDepartmentId] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState("");
  const [source, setSource] = useState([]);
  const [recruiter, setRecruiter] = useState([]);
  const [formId, setFormId] = useState([]);
  const [callMasterId, setCallMasterId] = useState("");
  const [whatsAppCampaign, setWhatsAppCampaign] = useState("");
  const [whatsAppResponse, setWhatsAppResponse] = useState("");
  const [positions, setPositions] = useState([]);
  const [qualification, setQualification] = useState([]);
  const [defaultDate, setDefaultDate] = useState([]);
  const [hiredCount, setHiredCount] = useState(0);
  const [talentpoolCount, setTalentPollCount] = useState(0);
  const [inProcessCount, setInProcessCount] = useState(0);
  const [subTabCount, setSubTabCount] = useState({});
  const [delaySubTabCount, setDelaySubTabCount] = useState({});
  const [newCount, setNewCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [dynamicRounds, setDynamicRounds] = useState([]);
  const [onHoldCount, setOnHoldount] = useState(0);
  const [candidateList, setCandidateList] = useState([]);
  const [headerFilterStatus, setHeaderFilterStatus] = useState(
    TAB || "Application_Received",
  );
  const [selectedDatevalue, setSelectedDatevalue] = useState("Last 30 Days");
  const [advanceappliedFilters, setAdvanceappliedFilters] = useState(0);
  const [normalFilters, setNormalFilters] = useState(0);
  const [versantScore, setVersantScore] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [candidateType, setCandidateType] = useState([]);
  const [callType, setCallType] = useState([]);
  const [interviewRound, setInterviewRound] = useState("");
  const [modeOfInterview, setModeOfInterview] = useState("");
  const [documentation, setDocumentation] = useState("");
  const [filterFetched, setFilterFetched] = useState(false);
  const [isNavigateFromTrf, setTsNavigateFromTrf] = useState(false);
  const [unassigned, setUnassigned] = useState(false);
  const [current, setCurrent] = useState(1);
  const [hirePage, setHirePage] = useState(1);
  const [rejectPage, setRejectPage] = useState(1);
  const [holdPage, setHoldPage] = useState(1);
  const [poolPage, setPoolPage] = useState(1);
  const [load, setLoad] = useState(true);
  const [frequency, setFrequency] = useState({
    Hired: 0,
    TalentPool: 0,
    In_Process: 0,
    Application_Received: 0,
    Rejected: 0,
    "On Hold": 0,
  });

  return (
    <SearchContextAPI.Provider
      value={{
        search,
        setSearch,
        location,
        setLocation,
        trfId,
        setTrfId,
        interviewStatus,
        setInterviewStatus,
        source,
        setSource,
        formId,
        setFormId,
        defaultDate,
        setDefaultDate,
        headerFilterStatus,
        setHeaderFilterStatus,
        selectedDatevalue,
        setSelectedDatevalue,
        qualification,
        setQualification,
        callMasterId,
        setCallMasterId,
        hiredCount,
        setHiredCount,
        talentpoolCount,
        setTalentPollCount,
        inProcessCount,
        setInProcessCount,
        newCount,
        setNewCount,
        rejectedCount,
        setRejectedCount,
        onHoldCount,
        setOnHoldount,
        candidateList,
        setCandidateList,
        recruiter,
        setRecruiter,
        positions,
        setPositions,
        advanceappliedFilters,
        setAdvanceappliedFilters,
        setNormalFilters,
        normalFilters,
        versantScore,
        setVersantScore,
        modeOfInterview,
        setModeOfInterview,
        interviewRound,
        setInterviewRound,
        filterFetched,
        setFilterFetched,
        subTabCount,
        setSubTabCount,
        dynamicRounds,
        setDynamicRounds,
        delaySubTabCount,
        setDelaySubTabCount,
        frequency,
        setFrequency,
        rotationalShift,
        setRotationalShift,
        interested,
        setInterested,
        current,
        setCurrent,
        unassigned,
        hirePage, 
        setHirePage,
        rejectPage, 
        setRejectPage,
        holdPage, 
        setHoldPage,
        poolPage, 
        setPoolPage,
        setUnassigned,
        isNavigateFromTrf,
        setTsNavigateFromTrf,
        jobType,
        setJobType,
        candidateType,
        setCandidateType,
        departmentId, 
        setDepartmentId,
        designationId, 
        setDesignationId,
        whatsAppCampaign, 
        setWhatsAppCampaign,
        whatsAppResponse, 
        setWhatsAppResponse,
        load, 
        setLoad,
        documentation, 
        setDocumentation,
        callType,
        setCallType,
      }}
    >
      {children}
    </SearchContextAPI.Provider>
  );
};

export default SearchContext;
